import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import Dashboard from "./tabs/Dashboard";
import LoadsTab from "./tabs/LoadsTab";
import DriversTab from "./tabs/DriversTab";
import VehiclesTab from "./tabs/VehiclesTab";
import ComplianceTab from "./tabs/ComplianceTab";

export function CarriersView() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Get the current tab from URL, default to 'dashboard'
  const currentTab = searchParams.get("tab") || "dashboard";

  const handleTabChange = (tab: string) => {
    // Update URL when tab changes
    navigate(`/carriers?tab=${tab}`);
  };

  return (
    <div className="container mx-auto p-6">
      <Tabs
        value={currentTab}
        onValueChange={handleTabChange}
        className="space-y-6"
      >
        <Dashboard />
        <TabsList className="grid grid-cols-4 border rounded-lg p-1">
          <TabsTrigger value="drivers">Drivers</TabsTrigger>
          <TabsTrigger value="vehicles">Vehicles</TabsTrigger>
          <TabsTrigger value="loads">Loads</TabsTrigger>
          <TabsTrigger value="compliance">Compliance</TabsTrigger>
        </TabsList>

        <TabsContent value="drivers">
          <DriversTab />
        </TabsContent>

        <TabsContent value="vehicles">
          <VehiclesTab />
        </TabsContent>

        <TabsContent value="loads">
          <LoadsTab />
        </TabsContent>

        <TabsContent value="compliance">
          <ComplianceTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
